<template>
    <div>
        <!-- sidebar e topo mobile são sempre escuros — logo clara nos dois temas -->
        <ULink to="/">
            <img src="/brand/logo-light.png" alt="Leadins" class="h-5 w-auto" />
        </ULink>
    </div>
</template>

<script setup>
</script>
